import React from 'react';

interface PencilIconProps {
  width?: number;
  height?: number;
  fill?: string;
}

const PencilIcon: React.FC<PencilIconProps> = ({ 
  width = 14, 
  height = 14, 
  fill = 'currentColor' 
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 14 14"
      fill="none"
    >
      <path
        d="M13.3333 3.49334C13.3339 3.40561 13.317 3.31863 13.2839 3.23741C13.2507 3.15618 13.2018 3.0823 13.14 3.02001L10.3133 0.193344C10.2511 0.131557 10.1772 0.0826734 10.0959 0.049497C10.0147 0.0163206 9.92775 -0.000496119 9.84001 1.11429e-05C9.75227 -0.000496119 9.6653 0.0163206 9.58407 0.049497C9.50285 0.0826734 9.42897 0.131557 9.36668 0.193344L7.48001 2.08001L0.193344 9.36668C0.131557 9.42897 0.0826734 9.50285 0.049497 9.58407C0.0163206 9.6653 -0.000496119 9.75227 1.11429e-05 9.84001V12.6667C1.11429e-05 12.8435 0.070249 13.0131 0.195273 13.1381C0.320297 13.2631 0.489867 13.3333 0.666678 13.3333H3.49334C3.58663 13.3384 3.67994 13.3238 3.76722 13.2905C3.85451 13.2572 3.93382 13.2059 4.00001 13.14L11.2467 5.85334L13.14 4.00001C13.2009 3.9354 13.2504 3.86103 13.2867 3.78001C13.2931 3.72687 13.2931 3.67315 13.2867 3.62001C13.2898 3.58898 13.2898 3.55771 13.2867 3.52668L13.3333 3.49334ZM3.22001 12H1.33334V10.1133L7.95334 3.49334L9.84001 5.38001L3.22001 12ZM10.78 4.44001L8.89334 2.55334L9.84001 1.61334L11.72 3.49334L10.78 4.44001Z"
        fill={fill}
        fillOpacity="0.88"
      />
    </svg>
  );
};

export default PencilIcon;
